<template>
	<transition name="modal" @keyup.esc.stop="showModal = false">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Novo atendimento de subgrupo</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div :class="{'form-group': true, 'has-error':errors.has('subgrupo') }">
								<label>Subgrupo</label>
								<select-subgrupo name="subgrupo" v-if="!dados.exibiInput" :show-text-danger-subgrupo="showTextDangerSubgrupo" :contrato-id="$route.params.distribuicaoContratoId" @setSubgrupoSelecionado="(subgrupoSelecionado)=>{setSubgrupoSelecionado(subgrupoSelecionado)}" v-validate="'required'"></select-subgrupo>
								<input class="form-control" disabled="true" type="text" :value="dados.nome_subgrupo" v-if="dados.exibiInput"  v-validate="'required'"  >
								<span v-show="errors.has('subgrupo')" class="help-block">{{ errors.first('subgrupo') }}</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label>Sexo</label>
								<select class="form-control" v-model="dados.sexo">
									<option value="0">Ambos</option>
									<option value="1">Masculino</option>
									<option value="2">Feminino</option>
								</select>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('idade_minima') }">
								<label>Idade mínima</label>
								<input type="number" min="0" class="form-control" v-model="dados.idade_minima" v-validate="(dados.idade_maxima ? 'required|max_value:' + dados.idade_maxima : '')" name="idade_minima" ref="idade_minima">
								<span v-show="errors.has('idade_minima')" class="help-block">Deve ser menor que a idade máxima</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('idade_maxima') }">
								<label>Idade máxima</label>
								<input type="number" max="110" class="form-control" v-model="dados.idade_maxima" v-validate=" (dados.idade_minima ? 'required|min_value:' + dados.idade_minima : '')" name="idade_maxima" ref="idade_maxima">
								<span v-show="errors.has('idade_maxima')" class="help-block">Deve ser maior que a idade mínima</span>
							</div>
						</div>
					</div>
					<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>Tipo Consumo</label>
									<select @change="trocaTipoConsumo" class="form-control" v-model="dados.tipo_consumo">
										<option value="0">Por Procedimento</option>
										<option value="1">Por Paciente</option>
									</select>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Atendimentos</label>
									<input :disabled="dados.tipo_consumo != 0" type="number" class="form-control" v-model="dados.quantidade_atendimento">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Local</label>
									<input :disabled="dados.tipo_consumo != 0" type="number" class="form-control" v-model="dados.quantidade_local">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Max. Pacientes</label>
									<input :disabled="dados.tipo_consumo != 1" type="number" class="form-control" v-model="dados.quantidade_paciente">
								</div>
							</div>
						</div>
					<div class="row">
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('data') }">
								<label for="">Data: </label>
								<input
									v-model="dados.data_atendimento"
									class="form-control"
									type="date"
									placeholder="DATA"
									v-validate="'required'"
									name="data"
									ref="data"
								>
								<span v-show="errors.has('data')" class="help-block">{{ errors.first('data') }}</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('hora_inicial') }">
								<label>Hora inicial</label>
								<input type="time" class="form-control" v-model="dados.hora_inicial" v-validate="'required'" name="hora_inicial" ref="hora_inicial">
								<span v-show="errors.has('hora_inicial')" class="help-block">{{ errors.first('hora_inicial') }}</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('hora_final') }">
								<label>Hora final</label>
								<input type="time" class="form-control" v-model="dados.hora_final" v-validate="'required'" name="hora_final" ref="hora_final">
								<span v-show="errors.has('hora_final')" class="help-block">{{ errors.first('hora_final') }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="row">
						<div class="col-md-12">
							<button
								@click="salvar()"
								class="btn btn-primary pull-right"
								type="button"
							><i class="fa fa-save"></i> Salvar</button>
							<button tag="a" @click="$emit('close')" class="btn btn-default pull-left"><i class="fa fa-close"></i> Cancelar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http
	import selectSubgrupo from "../contratos/selectDistribuicaoSubgruposContrato";

	export default {
		filters: { },
		props: ["show", "item"],
		data: () => ({
			showTextDangerSubgrupo: false,
			dados: {
				distribuicao_contrato_subgrupo_id: null,
				nome_subgrupo: '',
				sexo: 0,
				idade_maxima: '',
				idade_minima: '',
				tipo_consumo: 0,
				quantidade_atendimento: '',
				quantidade_local: '',
				quantidade_paciente: '',
				hora_inicial: '',
				hora_final: '',
				data_atendimento: '',
				exibiInput : false
			}
		}),
		mounted() {
			document.body.addEventListener('keyup', e => {
				if (e.keyCode === 27) {
				e.stopPropagation()
					this.$emit('close');
				}
			})
		},
		methods: {
			validar() {
				let validou = true;
				if (this.dados.distribuicao_contrato_subgrupo_id === null) {
					this.showTextDangerSubgrupo = true;
					validou = false;
				}
				return validou;
			},
			setSubgrupoSelecionado(subgrupoSelecionado) {
				console.log(subgrupoSelecionado);
				subgrupoSelecionado.subgrupo.nome ? this.showTextDangerSubgrupo = false : this.showTextDangerSubgrupo = true;
				this.dados.nome_subgrupo = subgrupoSelecionado.subgrupo.nome;
				this.dados.distribuicao_contrato_subgrupo_id = subgrupoSelecionado.id;
			},
			salvar() {
				let validado = this.validar();
				this.$validator.validateAll().then(result => {
					if (result && validado) {
						this.$store.commit('TOGGLE_LOADING');
						axios
							.post(
								`${this.$store.state.serverURI}/api/distribuicao/agenda/createProcedimentoAtendimentoSubgrupo`, this.dados,
								this.$store.getters.getHeaderAuth
							)
							.then(response => {
								this.$store.commit('TOGGLE_LOADING');
								this.$swal({
									type: "success",
									title: "Atendimento subgrupo criado com sucesso!",
									showConfirmButton: false,
									timer: 1500
								});
								this.$emit('atualizar');
								this.$emit('close');
							})
							.catch(error => {
								this.$store.commit('TOGGLE_LOADING');
								var erros = error.response.data.message + " ";
								for (var erro of Object.values(error.response.data.errors)) {
									erros += erro + " \n";
								}
								this.$swal({
									type: "error",
									title: "Houve uma falha!",
									text: erros
								});
							});
					}
				})
			},
			isEmpty(valor) {
				return valor === '';
			},
			hasDay() {
				return false;
			}
		},
		watch: {
			'show': function (value, oldValue) {

			},
			'dados.distribuicao_contrato_subgrupo_id': function(value) {
				if (value) {
					this.showTextDangerSubgrupo = false;
				}
			},
			item: {
				immediate: true,
				handler (value) {

					this.dados.exibiInput = false
					this.dados.idade_minima = ''
					this.dados.idade_maxima = ''
					this.dados.sexo = ''

					this.dados.nome_subgrupo = ''
					this.dados.distribuicao_contrato_subgrupo_id = ''

					if (value.contrato_subgrupo) {
						this.dados.exibiInput = value.autoChange
						this.dados.idade_minima = value.idade_minima
						this.dados.idade_maxima = value.idade_maxima
						this.dados.sexo = value.sexo

						this.dados.nome_subgrupo = value.contrato_subgrupo.subgrupo.nome
						this.dados.distribuicao_contrato_subgrupo_id = value.distribuicao_contrato_subgrupo_id

					}
				}
			},

		},
		components: {
			selectSubgrupo,
		},
	}
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}
	.v-select .dropdown-toggle {
		padding: 0 !important;
		border-radius: 0px !important;
	}

	.v-select input[type=search] {
		margin: 0 0 0 !important;
	}

	.v-select .selected-tag {
		margin: 5px !important;
	}
</style>



// WEBPACK FOOTER //
// criarAtendimentoSubgruposModal.vue?1d0cb0ed